export default (str) => {
  let text = str ? str + ""?.toLowerCase() || "" : "";
  let result = (text?.charAt(0)?.toUpperCase() || "") + (text?.slice(1) || "");

  return result;
};
